import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      icon: '🚀',
      title: 'Fast and Accurate',
      description: 'Get translations in seconds with high accuracy.',
    },
    {
      icon: '📄',
      title: 'Multiple File Types',
      description: 'Supports images, PDFs, and documents.',
    },
    {
      icon: '🔒',
      title: 'Secure and Confidential',
      description: 'Your files are safe with us.',
    },
    {
      icon: '💲',
      title: 'Affordable Pricing',
      description: 'Plans for every budget.',
    },
  ];

  return (
    <section className="bg-gradient-to-b  text-pl_txt_light_1 py-12 sm:py-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <h2 className="text-2xl sm:text-3xl font-poppins font-bold text-center mb-8 sm:mb-12 text-pl_prim_color_1">
          Features
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-4 sm:p-6 bg-pl_bg_light_3 rounded-xl shadow-md transition-transform hover:scale-105"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-lg sm:text-xl font-poppins font-bold mb-2 text-pl_txt_light_1">
                {feature.title}
              </h3>
              <p className="text-pl_txt_light_2 text-sm sm:text-base">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
